import React from 'react';
import TeamRegistrationLayout from './TeamRegistration/TeamRegistrationLayout';

const TeamRegistrationPage: React.FC = () => {
  return <TeamRegistrationLayout />;
};

export default TeamRegistrationPage;
